// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__oHxFK","searchArea":"styles_searchArea__3lumZ","treeWrapper":"styles_treeWrapper__29mFH"};